<template>
  <b-modal
    header-close-content=""
    ref="modal"
    id="export-progress-modal"
    class="export-progress-modal"
    body-class="overflow-auto"
    :title="$t('ExcelEdit')"
    centered
    no-close-on-backdrop
    no-close-on-esc
    ok-only
    :ok-title="!props.errors ? $t('cancel') : $t('Close')"
    :hide-footer="!props.isExport && !props.errors"
    v-model="intern_modalShow"
    @ok="$emit('cancel')"
    @hide="$emit('cancel')"
    data-cy="excel-edit-progress-mdl">
    <div class="export-progress-modal-content">
      <label>
        <strong v-if="!props.errors">{{ props.isExport ? $t("creatingExcelEditFile") : $t("importingExcelEditFile") }}</strong>
        <strong v-if="props.errors">{{ props.isExport ? $t("cantCreateExcelEditFile") : $t("cantImportingExcelEditFile") }}</strong>
      </label>
      <spinner-bar :animation-on="!props.errors" class="mb-3" />
      <div class="time-hint" v-if="!props.errors" v-dompurify-html="$t('excelEdit.timeHint')"></div>
      <Alert show variant="danger" v-if="props.errors">
        <span>{{ props.errors }}</span>
      </Alert>
    </div>
  </b-modal>
</template>
<script setup lang="ts">
import Alert from "@common/components/Alert.vue";
import SpinnerBar from "@common/components/SpinnerBar.vue";
import { ref, watch } from "vue";

//#region General
const intern_modalShow = ref<boolean>(false);
const $emit = defineEmits(["cancel", "update:modalShow"]);
const props = defineProps<{ isExport: boolean; modalShow: boolean; errors?: string }>();
//#endregion

//#region Show Control
watch(
  () => props.modalShow,
  (nv) => {
    intern_modalShow.value = nv;
  }
);
watch(intern_modalShow, (nv) => {
  $emit("update:modalShow", nv);
});
//#endregion
</script>
